import * as zod from 'zod';

import { ArmJointTorques } from '@sb/motion-planning';

export default zod.object({
  collisionThresholds: ArmJointTorques.optional(),
});
